import React, { VFC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Card, CardContainer, getSpacing, TextInput, TextView } from '@rahtab/ui';
import { withNumbers, withSeparator, withToman } from '@rahtab/system/lib/tools/string';

const OrderValue: VFC<OrderValueProps> = ({ onSubmitPress, unit, amount, onAmountChange, unitPrice, disabled }) => {
  return (
    <Card>
      <CardContainer>
        <View style={styles.inputUnitView}>
          <TextInput
            placeholder="مقدار سفارش را وارد نمایید."
            label="مقدار سفارش"
            keyboardType="numeric"
            style={styles.input}
            value={amount}
            onChangeText={withNumbers(onAmountChange)}
          />
          <TextView textContainerStyle={{ justifyContent: 'center' }} style={styles.unit} value={unit} />
        </View>
        <TextView
          title="مبلغ سفارش"
          isSpaceBetween
          value={!isNaN(parseFloat(amount)) ? withToman((parseFloat(amount) * unitPrice).toString()) : withToman(0)}
        />
        <Button text="ثبت سفارش" color="primary" onPress={onSubmitPress} disabled={disabled} />
      </CardContainer>
    </Card>
  );
};

export default OrderValue;

const styles = StyleSheet.create({
  inputUnitView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  input: {
    flex: 4,
  },
  unit: {
    width: 80,
    marginLeft: getSpacing(),
  },
  total: {
    marginBottom: getSpacing(),
  },
});

interface OrderValueProps {
  amount: string;
  unit?: string;
  unitPrice: number;
  disabled: boolean;
  onAmountChange: (amount: string) => void;
  onSubmitPress?: () => void;
}
